<template>
  <div class="">
    <div>
      <input-radio
          class="uk-form-control uk-form-control-large uk-padding uk-padding-remove-horizontal"
          v-model="selectedServices"
          :key="selectedServices"
          @change="filterChange"
          :options="services"
          :optionLabelKey="optionLabelKey"
          :optionChildrenKey="optionChildrenKey"
          name="services"
      />
    </div>

    <div class="uk-grid uk-child-width-expand@s">

      <div>
        <div class="uk-form-control uk-form-control-large">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="search"></span>
          <input type="search" :placeholder="sfModel.BackgroundHint" class="uk-input uk-box-shadow-medium" v-model="searchQuery" @change="filterChange" aria-autocomplete="both"/>
        </div>
      </div>

      <div class="uk-margin-small-top uk-margin-remove-top@s">
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedRepairCapabilities"
            :key="selectedRepairCapabilities"
            @change="filterChange"
            :options="repairCapabilities"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('RepairCapabilities')"
            name="categories"
        />
      </div>
    </div>
  </div>

</template>
<script setup>
import {onMounted, ref} from 'vue'
import InputCheckboxes from "./input-checkboxes.vue";
import {searchResults} from "./index";
import {sfUtil} from "../../util";
import InputRadio from "./input-radio.vue";

const props = defineProps({
  sfModel: Object,
  taxonomies: Object,
  additionalFilters: Object
})

const l = window.l

let additionalFilters = {...props.additionalFilters}

let taxonomies = {...props.taxonomies}

let services = taxonomies['services']
let repairCapabilities = taxonomies['repairCapabilities']

const searchQuery = ref('')
const selectedRepairCapabilities = ref(new Set());
const selectedServices = ref();

let initialResultsHtml = null

const REPAIR_CAPABILITIES_KEY = 'repair-capabilities'
const SERVICES_KEY = 'services'

const {
  optionLabelKey,
  optionValueKey,
  optionChildrenKey,
  getSearchParams,
  objectByValueKeys,
  findSearchResultsContainer
} = sfUtil.useBaseSearch();

const searchResultsContainer = findSearchResultsContainer()

onMounted(() => {
  window.addEventListener('popstate', () => {
    updateSearchResults()
  })

  if (searchResultsContainer && !sfUtil.hasActiveFiltering()) {
    initialResultsHtml = searchResultsContainer.innerHTML
  }
  initFilterState()
})

let initFilterState = () => {
  let searchParams = getSearchParams()
  searchQuery.value = searchParams.get('searchQuery')
  selectedRepairCapabilities.value = objectByValueKeys(new Set(searchParams.get(REPAIR_CAPABILITIES_KEY)?.split(',')), repairCapabilities)

  const searchServices = getSearchServices()

  if (searchServices.size > 1) {
    selectedServices.value = null
  } else if(searchServices.size === 1){
    const [service] = searchServices
    selectedServices.value = service
  }
}


const getSearchServices = () => {
  let searchParams = getSearchParams()
  return objectByValueKeys(new Set(searchParams.get(SERVICES_KEY)?.split(',')), services)
}


window.addEventListener('popstate', () => {
  initFilterState()
})

initFilterState()

let filterChange = () => {

  const url = new URL(window.location);

  let repairCapabilitiesSearch = [...selectedRepairCapabilities.value].map(v => v[optionValueKey]).join(',')
  let servicesSearch = selectedServices.value ? selectedServices.value[optionValueKey] : null

  if (repairCapabilitiesSearch) {
    url.searchParams.set(REPAIR_CAPABILITIES_KEY, repairCapabilitiesSearch)
  } else {
    url.searchParams.delete(REPAIR_CAPABILITIES_KEY)
  }

  if (servicesSearch) {
    url.searchParams.set(SERVICES_KEY, servicesSearch)
  }

  if (servicesSearch || repairCapabilitiesSearch || searchQuery.value) {
    url.searchParams.set('searchQuery', searchQuery.value || '')
    url.searchParams.set('language', props.sfModel['Language'])

    if(!servicesSearch){
      url.searchParams.set(SERVICES_KEY, services.map(s => s[optionValueKey]).join(','))
    }

    applyAdditionalFilters(url)
  } else {
    url.searchParams.delete('searchQuery')
  }

  if (url.searchParams.has('searchQuery')) {
    url.searchParams.set('indexCatalogue', props.sfModel['IndexCatalogue'])
  } else {
    url.searchParams.delete('indexCatalogue')
    url.searchParams.delete('searchQuery')
    url.searchParams.delete('language')
    url.searchParams.delete(SERVICES_KEY)
    removeAdditionalFilters(url)
  }

  url.pathname = url.pathname.replace(sfUtil.sfPathnamePagingRegex, '')

  url.searchParams.delete('page')

  window.history.pushState({}, '', url);

  updateSearchResults()
}

let applyAdditionalFilters = (url) => {
  if (!additionalFilters) return
  for (let k in additionalFilters) {
    url.searchParams.set(k, additionalFilters[k])
  }
}

let removeAdditionalFilters = (url) => {
  if (!additionalFilters) return
  for (let k in additionalFilters) {
    url.searchParams.delete(k)
  }
}

let updateSearchResults = () => {
  initSearchResults()
  document.dispatchEvent(new Event('searchPredicateChanged'))
}

let searchResultsApp = null

let initSearchResults = () => {
  if (searchResultsApp) return
  searchResultsApp = Vue.createApp(searchResults, {initialResultsHtml})
  searchResultsApp.mount(searchResultsContainer)
  window.searchResultApp = searchResultsApp
}

</script>
